export const tField = (object, fieldName, defaultValue = undefined) => (
  object?.translation?.[fieldName] || object?.[fieldName] || defaultValue
)
